import { render, staticRenderFns } from "./DetailsNewIncrement.vue?vue&type=template&id=0184300a&scoped=true"
import script from "./DetailsNewIncrement.vue?vue&type=script&lang=js"
export * from "./DetailsNewIncrement.vue?vue&type=script&lang=js"
import style0 from "./DetailsNewIncrement.vue?vue&type=style&index=0&id=0184300a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0184300a",
  null
  
)

export default component.exports